import { render, staticRenderFns } from "./nofity.vue?vue&type=template&id=45d19f8a&scoped=true&"
import script from "./nofity.vue?vue&type=script&lang=js&"
export * from "./nofity.vue?vue&type=script&lang=js&"
import style0 from "./nofity.vue?vue&type=style&index=0&id=45d19f8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d19f8a",
  null
  
)

export default component.exports